import React, {Component} from 'react'
import Barcode from './data/Barcode'
import ColorspaceDisplay from './data/ColorspaceDisplay'
import PrinterDisplay from './data/PrinterDisplay'
import CreatedDate from './data/CreatedDate'
import PropTypes from 'prop-types'
import LabelActions from './data/LabelActions'

class FileItem extends Component {
    render() {
        const {file, onFetchFiles, onChange} = this.props
        const {barcode_number, colorspace, item_number, printer, _id, updated_at} = file
        const barcodeItem = barcode_number + '_' + item_number

        return (
            <tr className='FileItem'>
                <Barcode barcode={barcodeItem}/>
                <ColorspaceDisplay colorspace={colorspace} onChange={onChange}/>
                <PrinterDisplay printer={printer} onChange={onChange}/>
                <CreatedDate created={updated_at}/>
                <LabelActions file={file} fileId={_id} barcode={barcodeItem} onFetchFiles={onFetchFiles}/>
            </tr>
        )
    }
}

FileItem.propTypes = {
    file: PropTypes.object.isRequired,
    onFetchFiles: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default FileItem
